export default {
    hero: {
        title: "Eve Mind",
        claim: "Il Trade Copilot rivoluzionario",
        description: "Una piattaforma per spedire, controllare, assicurare e pagare – alimentata dall'AI",
        ctaLogin: "Accedi",
        ctaGoToApp: "Vai all'area riservata",
        ctaContact: "Contattaci",
    },
    cta: {
        headline: "COMMERCIO GLOBALE: UN'INDUSTRIA DA $30T ANCORA BASATA SU EMAIL ED EXCEL.",
        subline: "Questo sta per cambiare",
    },
    agents: {
        care: {
            title: "Eve Care",
            subtitle: "Agente AI per il Customer Care",
            description: "Un agente AI per il customer care context aware grazie a training sulle info dell'account utente. Comprende le richieste, risponde in tempo reale, aggiorna i clienti sullo stato delle spedizioni, chiama i vettori esterni e registra automaticamente tutte le interazioni nel sistema. Può anche negoziare tariffe, riconoscendo i margini disponibili per ottimizzare ogni carico.",
            features: [
                "Risponde alle richieste dei clienti in tempo reale",
                "Aggiorna automaticamente i clienti sullo stato delle spedizioni",
                "Negozia tariffe e ottimizza i margini",
                "Registra automaticamente tutte le interazioni",
            ],
        },
        track: {
            title: "Eve Track",
            subtitle: "Agente per il Tracciamento in Tempo Reale",
            description: "Un agente AI che collega in tempo reale i dati satellitari, le comunicazioni dei vettori e i sistemi gestionali. Risponde automaticamente ai clienti che chiedono aggiornamenti, consulta i dati GPS o chiama il vettore o l'autista per ottenerne la posizione. Eve Track raccoglie, verifica e aggiorna lo stato di ogni spedizione, creando una visibilità completa generando notifiche automatiche in caso di ritardi o anomalie. Il customer care non deve più 'cercare informazioni': le riceve già pronte, affidabili e in tempo reale.",
            features: [
                "Collega dati satellitari e GPS in tempo reale",
                "Risponde automaticamente alle richieste di aggiornamento",
                "Genera notifiche per ritardi e anomalie",
                "Fornisce visibilità completa delle spedizioni",
            ],
        },
        quote: {
            title: "Eve Quote",
            subtitle: "Agente AI per le Quotazioni",
            description: "L'agente AI che automatizza e gestisce l'intero ciclo di vita della quotazione, dalla ricezione della richiesta fino al follow-up con il cliente. Eve Quote legge e interpreta automaticamente le richieste in arrivo, estrae i dati chiave e calcola in pochi secondi la tariffa più adatta utilizzando i tuoi listini e regole di pricing. Genera un'offerta professionale, già pronta per essere inviata, e continua a seguire la conversazione: risponde a eventuali domande, gestisce modifiche o aggiornamenti della quotazione e mantiene lo storico di tutte le interazioni. Archivia e indicizza automaticamente ogni preventivo, rendendo semplicissimo ritrovare in un click le offerte precedenti senza dover ripescare email o thread di conversazioni.",
            features: [
                "Calcola tariffe in pochi secondi usando le tue regole di pricing",
                "Genera offerte professionali pronte da inviare",
                "Gestisce modifiche e aggiornamenti automaticamente",
                "Archivia e indicizza ogni preventivo per facile recupero",
            ],
        },
        read: {
            title: "Eve Read",
            subtitle: "Agente AI per la Lettura Documenti",
            description: "Legge e interpreta automaticamente ogni documento, indipendentemente dal formato. Estrae i dati chiave, li struttura e li invia direttamente al TMS, segnalando subito eventuali anomalie. Eve Read non si limita a leggere: impara come vuoi che siano organizzati i tuoi dati, e lo fa sempre meglio.",
            features: [
                "Legge documenti in qualsiasi formato automaticamente",
                "Estrae e struttura i dati chiave istantaneamente",
                "Invia i dati direttamente al tuo TMS",
                "Impara le tue preferenze di organizzazione dati",
            ],
        },
        plan: {
            title: "Eve Plan",
            subtitle: "Agente AI per la Pianificazione",
            description: "Analizza i flussi di ordini, la disponibilità dei mezzi e le restrizioni operative, suggerendo il piano di viaggio più efficiente per ogni giornata. Quando cambiano le condizioni - un ritardo, un nuovo ordine o un guasto - il sistema ricalcola le priorità in tempo reale, proponendo al responsabile della logistica la soluzione ottimale da approvare o modificare.",
            features: [
                "Suggerisce i piani di viaggio più efficienti quotidianamente",
                "Ricalcola le priorità in tempo reale quando cambiano le condizioni",
                "Considera disponibilità mezzi e restrizioni operative",
                "Propone soluzioni ottimali per l'approvazione del manager",
            ],
        },
    },
    features: {
        label: "Caratteristiche",
        title: "Agenti AI potenti per trasformare le tue operazioni commerciali",
        description: "Cinque agenti intelligenti che lavorano insieme per automatizzare, ottimizzare e rivoluzionare il tuo flusso di lavoro logistico. Fidati di aziende visionarie in tutto il mondo.",
    },
    footer: {
        contactTitle: "Pronto a trasformare la tua logistica?",
        contactDescription: "Contatta il nostro team per saperne di più su Eve Mind.",
        contactButton: "Contattaci",
        loginLink: "Hai già un account?",
        loginButton: "Accedi",
    },
};

